<template>
    <div class="app flex-row align-items-center bg-dark bg_partern">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="8" sm="10">
            <b-card-group>
              <b-card no-body class="p-4 bg-dark">
                <b-card-body>
  
                  <b-form >
                    <h1>Odebox User Data</h1>
                    <p class="text-muted">Request Data Deletion</p>
                    <b-input-group class="mb-3">
                      <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                      <b-form-input v-model="email" type="email" class="form-control" placeholder="email" />
                    </b-input-group>

                    <b-input-group class="mb-3">
                      <b-input-group-prepend><b-input-group-text><i class="fa fa-book"></i></b-input-group-text></b-input-group-prepend>
                      <b-form-textarea v-model="instructions" type="text" class="form-control" placeholder="instructions"  max-rows="8" rows="4"/>
                    </b-input-group>
  
  
                    <b-row v-if="!loading">
                      
  
                      <b-col cols="12">
                        <b-button  block class="btn primary" type="button" @click="sendDeleteReq" :disabled="email.length<2||instructions.length<2"><span>Send Request</span></b-button>
                      </b-col>
                    </b-row>
                    <vue-loaders-ball-beat v-if="loading" color="red" scale="1"></vue-loaders-ball-beat>
                  </b-form>
                </b-card-body>
              </b-card>
              <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
                <b-card-body class="text-center">
                  <div>
                    <h2>Request Deletion</h2>
                    <p>Here you can request for your data to be deleted from our servers. Depending on your instructions, this could include your account information. These requests are typically honored within 90 days.</p>
  
                     
                  </div>
                </b-card-body>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
  </template>
  
  <script>
  import {createGeneralItemJsonPost, getBaseURL} from '../../services/v1/api_store';
  import {DEFAULT_TOAST} from '../../services/v1/constants';
  
  const opts = DEFAULT_TOAST;
  
  export default {
    name: 'RequestDelete',
    data () {
      return {
        loading: false,
        email: '',
        instructions: ''
      }
    },
    mounted () {
  
    },
     methods: {
  
       sendDeleteReq() {

        let self = this;

        self.loading = true;
  
        createGeneralItemJsonPost(
            getBaseURL() + `gdpr/request_delete`,
           {
             email: self.email,
             instructions: self.instructions
           }, text => self.onDeleteReqComplete(text));
       },
  
       onDeleteReqComplete (resp) {

        this.loading = false;

         console.log(resp)

            if(resp.code ===200){
            this.$toasted.show('Request Sent', opts)
            }
            else {
            this.$toasted.show('Request Failed, try again', opts)
            }
       }
     }
  }
  </script>
  
  <style scoped>
    .bg_partern {
      background: url(../../../public/img/bg_item.svg) no-repeat center center fixed;
      background-size: cover;
    }
  </style>
  